import PonchoIcon from "./PonchoIcon";

export default function ReciclajeBasuraIcon({ ...props }) {
  return <PonchoIcon name="reciclaje-basura" {...props} />;
}
